export const blurActiveElement = () => {
  const activeEl = document.activeElement;
  if (activeEl && 'blur' in activeEl && typeof activeEl.blur === 'function') {
    (activeEl as HTMLElement).blur();
  }
};
